export function readBlob(b: Blob): Promise<string> {
	return new Promise(function (resolve, reject) {
		const reader = new FileReader()

		reader.onloadend = function () {
			// @ts-ignore
			resolve(reader.result)
		}
		reader.onerror = function (arg) {
			reject(arg)
		}

		reader.readAsDataURL(b)
	})
}

/** Formats a byte count as decimal megabytes with one decimal, e.g. 7000000 → "7,0 MB" for nl. */
export function formatMegabytes(bytes: number, locale?: string): string {
	const megabytes = bytes / 1_000_000

	return `${megabytes.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} MB`
}
